import {
  FLIGHTS_ANDROID_SHARE_DIRECT_LABEL,
  FLIGHTS_ANDROID_SHARE_META_LABEL,
  FLIGHTS_IOS_SHARE_DIRECT_LABEL,
  FLIGHTS_IOS_SHARE_META_LABEL
} from "@flights/constants";
import { createTrackingUtils } from "../index";

export const trackIOSShareFlightWebAA = createTrackingUtils({
  name: "ios_flights_share_flight_landing_web_aa",
  defaultStage: 1,
  stages: {
    flight_details: 1, //main
    desktop: 2,
    mobile: 3,
    meta: 4,
    direct: 5
  },
  goals: {},
  goalsWithValue: []
});

export const trackAndroidShareFlightWebAA = createTrackingUtils({
  name: "android_flights_share_flight_landing_web_aa",
  defaultStage: 1,
  stages: {
    flight_details: 1, //main
    desktop: 2,
    mobile: 3,
    meta: 4,
    direct: 5
  },
  goals: {},
  goalsWithValue: []
});

export const trackAppsShareFlightWebAAStages = (isMobile: boolean, label?: string) => {
  if (label && [FLIGHTS_IOS_SHARE_DIRECT_LABEL, FLIGHTS_IOS_SHARE_META_LABEL].includes(label)) {
    trackIOSShareFlightWebAA.stages.flight_details();
    isMobile ? trackIOSShareFlightWebAA.stages.mobile() : trackIOSShareFlightWebAA.stages.desktop();
    label == FLIGHTS_IOS_SHARE_META_LABEL
      ? trackIOSShareFlightWebAA.stages.meta()
      : trackIOSShareFlightWebAA.stages.direct();
  } else if (label && [FLIGHTS_ANDROID_SHARE_DIRECT_LABEL, FLIGHTS_ANDROID_SHARE_META_LABEL].includes(label)) {
    trackAndroidShareFlightWebAA.stages.flight_details();
    isMobile ? trackAndroidShareFlightWebAA.stages.mobile() : trackAndroidShareFlightWebAA.stages.desktop();
    label == FLIGHTS_ANDROID_SHARE_META_LABEL
      ? trackAndroidShareFlightWebAA.stages.meta()
      : trackAndroidShareFlightWebAA.stages.direct();
  }
};
